import { createFileRoute } from "@tanstack/react-router";
import { AdminClientDetailPage } from "@/pages/admin-client-detail/ui/admin-client-detail-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/clients/$clientId",
)({
  component: AdminClientDetailPage,
});
